<template>
  <div class="patient-events__item-content stat-alarm" :class="`stat-alarm--${payload.event_type} stat-alarm--${payload.alarm_type}`">
    <p><span class="key">Type:</span> <span class="is-capitalized">{{ getType(payload) }}</span></p>
    <p v-if="!hideTimeOfEvent"><span class="key">Time of Event:</span> <span class="is-capitalized">{{ $helpers.formatDate(payload.date) }}</span></p>
    <p v-if="payload.stat_alarm_category || payload.stat_alarm_category_id">
      <span class="key">Category:</span> <span>{{ getCategoryName(payload) }}</span>
    </p>
    <p v-if="getType(payload) == 'alarm' && payload.event_type">
      <span class="key">Resolution Type:</span> <span class="is-capitalized">{{ payload.event_type }}</span>
    </p>
    <p v-if="payload.description"><span class="key">Message:</span> <span>{{ payload.description }}</span></p>
    <p v-if="payload.acuity_score != null"><span class="key">Attention Score:</span> <span>{{ parseFloat(payload.acuity_score).toFixed(1) }}</span></p>
  </div>
</template>

<script>
export default {
  name: "StatAlarmEvent",
  props: {
    payload: { type: Object, required: true },
    categories: { type: Array, required: false, default: () => [] },
    hideTimeOfEvent: { type: Boolean, required: false, default: false}
  },
  computed: {
    categoriesObj() {
      return this.categories.reduce((acc, curr) => {
        acc[curr.id] = curr.label
        return acc
      }, {})
    },
  },
  methods: {
    getType(alarm) {
      return alarm.alarm_type == 'alarm' ? 'alarm' : alarm.event_type
    },
    getCategoryName(payload) {
      if (payload.stat_alarm_category) {
        return payload.stat_alarm_category
      } else if (payload.stat_alarm_category_id) {
        return this.categoriesObj[payload.stat_alarm_category_id]
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .stat-alarm p {
    font-size: 14px;
  }
  .key {
    font-weight: 500;
  }
  .stat-alarm__title {
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0.7px;
    padding-bottom: 5px;
  }
  .patient-events--compact .stat-alarm__title {
    font-size: 10px;
  }
  .stat-alarm.open {
    box-shadow: none !important;
  }
  .stat-alarm--note {
    background: $is-note-background !important;
    span {
      color: $is-note-text !important;
    }
    &.has-revisions {
      box-shadow: 1px 1px 0 1px #73a2f1, 2px 2px 0 2px #578fef, 3px 4px 0 2px #467bd8;
    }
  }
  .stat-alarm--prevented {
    background: $is-prevented-background !important;
    span {
      color: $is-prevented-text !important;
    }
    &.has-revisions {
      box-shadow: 1px 1px 0 1px #facb42, 2px 2px 0 2px #f8b800, 3px 4px 0 2px #cc9600
    }
  }
  .stat-alarm--occurred {
    background: $is-occurred-background !important;
    span {
      color: $is-occurred-text !important;
    }
    &.has-revisions {
      box-shadow: 1px 1px 0 1px #e28800, 2px 2px 0 2px #c27501, 3px 4px 0 2px #b16b00;
    }
  }
  .stat-alarm--alarm {
    background: $is-alarm-background !important;
    span {
      color: $is-alarm-text !important;
    }
    &.has-revisions {
      box-shadow: 1px 1px 0 1px #ff6161, 2px 2px 0 2px #dd5151, 3px 4px 0 2px #b14749;
    }
  }
</style>
